import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: false,
};

const userSlice = createSlice({
  name: "user", // Slice name
  initialState, // Initial state
  reducers: {
    updateUser: (state, action) => {
      state.user = action.payload;
    },
    logOutUser: (state) => {
      state.user = false;
    },
  },
});

export const { updateUser, logOutUser } = userSlice.actions;
export default userSlice.reducer;
